import React, { useState, useEffect } from 'react';
import './loader.css';  // Import CSS for the loader

const Loader = () => {
  const [percentage, setPercentage] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setPercentage((prev) => {
        if (prev >= 100) {
          clearInterval(timer);
          return 100;
        }
        return prev + 1;
      });
    }, 50);  // Faster update interval for smoother animation

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="loader-container">
      <div className="stars"></div>
      <div className="nebula"></div>
      <div className="loader-circle">
        <div
          className="progress"
          style={{
            background: `conic-gradient(#ff7f50 ${percentage}%, transparent 0)`,
          }}
        ></div>
        <div className="timer">{percentage}%</div>
      </div>
    </div>
  );
};

export default Loader;
